import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Table,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import apiClient from "../../utils/apiClient";
const AssignTechnician = () => {
  const { bookingId } = useParams();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [technicians, setTechnicians] = useState([]);
  const navigate = useNavigate();
  const fetchTechnicians = async () => {
    try {
      const res = await apiClient.get(`/technician/nearbytechnician/${bookingId}`);
      if (res?.data?.status) {
        setTechnicians(res.data.technicians);
      }
    } catch (error) {
      setError(error.message || "Failed to fetch booking");
    } finally {
      setLoading(false);
    }
  };

  const handleAssignTechnician = async (technicianId) => {
    console.log(technicianId, "technicianId");
    console.log(bookingId, "bookingId");
    try {
      const res = await apiClient.post(`/bookings/manualassignbooking`, {
        bookingId,
        technicianId,
      });
      if (res?.data?.status) {
        navigate("/display-bookings");
      }
    } catch (error) {
      setError(error.message || "Failed to assign technician");
    }
  };
  const handleViewClick = (techinicianId) => {
    navigate("/view-techinician-details", { state: { techinicianId } });
  };
  useEffect(() => {
    fetchTechnicians();
  }, [bookingId]);

  return (
    <Box p={3} mt={2}>
      <Typography variant="h6" gutterBottom>
        Assign Technician
      </Typography>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center">
          <CircularProgress />
        </Box>
      ) : (
        <Box mt={2}>
          <Typography variant="subtitle1" gutterBottom>
            Available Technicians
          </Typography>
          <TableContainer component={Paper}>
            <Table aria-label="Technicians Table">
              <TableHead>
                <TableRow>
                  <TableCell>Profile</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Phone</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Rating</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {technicians.map((tech) => (
                  <TableRow key={tech.id}>
                    <TableCell>
                      <Avatar alt={tech.firstName} src={tech.profileImage} />
                    </TableCell>
                    <TableCell>
                      {tech.firstName} {tech.lastName}
                    </TableCell>
                    <TableCell>{tech.phone}</TableCell>
                    <TableCell>{tech.email}</TableCell>
                    <TableCell>{tech.overAllRating}</TableCell>
                    <TableCell>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        gap={1}
                      >
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => handleAssignTechnician(tech.id)}
                        >
                          Assign
                        </Button>
                        <VisibilityIcon
                          onClick={() => handleViewClick(tech.id)}
                          sx={{ cursor: "pointer" }}
                        />
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {error && (
            <Box sx={{ mt: 2, color: "red" }}>
              <Typography variant="body2" color="error">
                {error}
              </Typography>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default AssignTechnician;
